import React, { useState } from "react";
import "../App.css";
import { Tabs } from "./Tabs";
import { Footer } from "./Footer";

export function Body({
  divisions,
  checkedDivisions,
  searchQueues,
  searchWrapupCodes,
}) {
  const [pageCount, setPageCount] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [activeTab, setActiveTab] = useState("Queues");
  const handleClick = (event) => {
    setActiveTab(event.target.innerText);
  };

  const onPageChange = (pageNumber) => {
    setPageNumber(pageNumber);
  };

  return (
    <>
      <Tabs
        divisions={divisions}
        checkedDivisions={checkedDivisions}
        pageCount={pageCount}
        setPageCount={setPageCount}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
        onPageChange={onPageChange}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        handleClick={handleClick}
        searchQueues={searchQueues}
        searchWrapupCodes={searchWrapupCodes}
      />

      {activeTab === "Create Wrapup Codes" ? (
        ""
      ) : (
        <Footer
          checkedDivisions={checkedDivisions}
          pageCount={pageCount}
          pageNumber={pageNumber}
          onPageChange={onPageChange}
        />
      )}
    </>
  );
}
